import { useState } from "react";
import MealCard from "../components/MealCard";
import { featuredMeals, mealTags } from "../mock";

const ALL = "ALL";

export default function MenuPage() {
  const [filter, setFilter] = useState(ALL);
  const filtered = filter === ALL ? featuredMeals : featuredMeals.filter((m) => m.tag === filter);

  return (
    <main>
      <section className="bg-gradient-to-b from-amber-50 to-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20 text-center">
          <p className="text-sm font-bold tracking-widest text-green-700">MENU</p>
          <h1 className="mt-2 text-4xl md:text-5xl font-extrabold text-neutral-900">This week&apos;s meals</h1>
          <p className="mt-3 text-neutral-600 max-w-2xl mx-auto">
            A rotating menu of nutritionist-approved dishes. No repeats within the week.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-wrap gap-2 justify-center">
          {[ALL, ...mealTags].map((t) => (
            <button
              key={t}
              onClick={() => setFilter(t)}
              className={`tag-pill text-xs font-bold tracking-wider px-3 py-1.5 rounded-full border ${
                filter === t
                  ? "bg-green-600 border-green-600 text-white"
                  : "bg-white border-neutral-300 text-neutral-700 hover:border-green-600 hover:text-green-700"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((m) => (
            <MealCard key={m.name} meal={m} />
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="text-center text-neutral-500 py-10">No meals in this category yet. Check back soon!</p>
        )}
      </section>
    </main>
  );
}
